import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconClose from 'yoda-core-components/lib/assets/svg/IconClose.svg';
import IconSuccess from 'yoda-core-components/lib/assets/svg/IconSuccess.svg';
import IconError from 'yoda-core-components/lib/assets/svg/IconError.svg';
import IconInformation from 'yoda-core-components/lib/assets/svg/IconInformation.svg';
import {
    CREAT_ACCOUNT_TITILE_INFORMATION,
    CREAT_ACCOUNT_TITILE_SUCCESS,
    CREAT_ACCOUNT_TITILE_ERROR,
    CREATE_ACCOUNT_MESSAGE_CATEGOR_INFORMATION,
    CREATE_ACCOUNT_MESSAGE_CATEGOR_ERROR,
    CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './CreateAccountMessage.css';

const cx = classNames.bind(styles);

const messageCategories = {
    success: {
        createAccountTitle: CREAT_ACCOUNT_TITILE_SUCCESS,
        iconName: 'icon-success',
        iconComponent: <IconSuccess />,
        wrapperStyle: `${'confirmationMsgSuccess'} ${dt(['p-0'])}`,
        colorStyle: `${styles.successColor} ${dt([
            'font-open-sans-bold',
            'text-black',
            'smMd:text-xlarge',
            'lg:text-large',
            'font-bold',
            'mb-2',
            'pt-0',
        ])}`,
        dataAutomationIdIcon: 'at-createAcc-success-icon',
        dataAutomationIdTitle: 'at-createAcc-success-title',
        dataAutomationIdBody: 'at-createAcc-success-body',
    },
    error: {
        createAccountTitle: CREAT_ACCOUNT_TITILE_ERROR,
        iconName: 'icon-error',
        iconComponent: <IconError />,
        wrapperStyle: `${'confirmationMsgError'} ${dt([
            'border-solid',
            'border-l-4',
            'border-error-border',
            'shadow-elevation1',
            'bg-error-fill',
            'p-3',
        ])}`,
        colorStyle: `${styles.errorColor} ${dt([
            'font-open-sans-regular',
            'text-normal',
            'text-black',
        ])}`,
        dataAutomationIdIcon: 'at-createAcc-error-icon',
        dataAutomationIdTitle: 'at-createAcc-error-title',
        dataAutomationIdBody: 'at-createAcc-error-body',
    },
    information: {
        createAccountTitle: CREAT_ACCOUNT_TITILE_INFORMATION,
        iconName: 'icon-information',
        iconComponent: <IconInformation />,
        wrapperStyle: `${'confirmationMsgInfo'} ${dt([
            'py-2.5',
            'px-0',
            'rounded',
            'border-solid',
            'border',
            'border-link-hover',
            'shadow-elevation1',
            'bg-link-darkbg-Hover',
        ])}`,
        colorStyle: `${styles.infoColor} ${dt([
            'text-link-hover',
            'opacity-75',
            'font-open-sans-bold',
        ])}`,
        dataAutomationIdIcon: 'at-createAcc-info-icon',
        dataAutomationIdTitle: 'at-createAcc-info-title',
        dataAutomationIdBody: 'at-createAcc-info-body',
    },
};

class CreateAccountMessage extends Component {
    static propTypes = {
        message: PropTypes.string,
        messageTitle: PropTypes.string,
        messageCategory: PropTypes.oneOf([
            CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS,
            CREATE_ACCOUNT_MESSAGE_CATEGOR_ERROR,
            CREATE_ACCOUNT_MESSAGE_CATEGOR_INFORMATION,
        ]).isRequired,
        isCloseIconRequired: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        message: '',
        messageTitle: '',
    };

    constructor() {
        super();
        this.state = {
            isOpen: true,
        };
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal(event) {
        event.preventDefault();
        this.setState({
            isOpen: false,
        });
    }

    render() {
        const { message, messageTitle, messageCategory, isCloseIconRequired } = this.props;
        if (!this.state.isOpen) {
            return null;
        }
        return (
            <div
                className={`${styles.createAccountNotification} ${dt(['m-0'])}`}
                data-automation-id="at-create-acc-notification-wrapper"
            >
                <div
                    data-automation-id="at-notification-wrapper"
                    className={`${cx(
                        'messageOuterWrapper',
                        messageCategories[messageCategory].wrapperStyle
                    )} ${dt(['flex'])}`}
                >
                    <div
                        data-automation-id={messageCategories[messageCategory].dataAutomationIdIcon}
                        className={`${cx('iconWrapper')} ${dt([
                            messageCategories[messageCategory].iconName !== 'icon-error'
                                ? 'smMd:leading-[30px]'
                                : '',
                            messageCategories[messageCategory].iconName !== 'icon-error'
                                ? 'lg:leading-[22px]'
                                : '',
                        ])}`}
                    >
                        <Icon iconType="svg" width="22px" height="22px" viewBox="0 0 48 48">
                            {messageCategories[messageCategory].iconComponent}
                        </Icon>
                    </div>
                    <div
                        className={`${cx('messageWrapper')} ${dt([
                            'pl-3',
                            'text-sm',
                            'leading-7',
                        ])}`}
                        data-automation-id="at-create-acc-msg-wrapper"
                    >
                        <p
                            data-automation-id={
                                messageCategories[messageCategory].dataAutomationIdTitle
                            }
                            className={messageCategories[messageCategory].colorStyle}
                        >
                            {messageTitle || messageCategories[messageCategory].createAccountTitle}
                        </p>
                        <p
                            data-automation-id={
                                messageCategories[messageCategory].dataAutomationIdBody
                            }
                            className={`${styles.messageBodyWrapper} ${dt([
                                'text-black',
                                'smMd:text-normal',
                                'lg:text-small',
                            ])}`}
                            data-qm-block="true"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: message }}
                        />
                    </div>
                    <div className={cx('closeIconWrapper')}>
                        {isCloseIconRequired ? (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                                href=""
                                data-automation-id="at-close-modal"
                                onClick={this.closeModal}
                            >
                                <Icon iconType="svg" width="22px" height="22px" viewBox="0 0 48 48">
                                    <IconClose />
                                </Icon>
                            </a>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateAccountMessage;
